module.exports = __webpack_public_path__ + "assets/img/kroscina-wielka-2x.4688e4d2.jpg";